export default "__VITE_ASSET__CpIGZo56__"